import { render } from "./TopThree.vue?vue&type=template&id=893f2434&scoped=true"
import script from "./TopThree.vue?vue&type=script&lang=js"
export * from "./TopThree.vue?vue&type=script&lang=js"

import "./TopThree.vue?vue&type=style&index=0&id=893f2434&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\AirFryer\\AirFryer_Berater\\AirFryer_Kaufberatung\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-893f2434"]])

export default __exports__